import { Injectable } from "@angular/core"
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { AiCdsAlertAction, DsiRecommAction } from "./ai-cds.action";
 
export class AICdsStateModel{
    aiCdsObj:any;
    recommendationObj:any;
    
 }
 @State<AICdsStateModel>({
    name: 'AICdsStateModelIDs',
    defaults: {
        aiCdsObj:null,
        recommendationObj:null
     }
})
@Injectable()
 export class AiCdsAlertState {
    constructor( ) {
    }

    @Selector()
    static getAICdsAlertsData(state: AICdsStateModel) {
        return state;
    }

    @Action(AiCdsAlertAction)
    storeAiCdsAlertAction({getState, patchState}: StateContext<AICdsStateModel>, {payload}: AiCdsAlertAction) {

        const state = getState();
        patchState({
            aiCdsObj: payload,
            
        });
    }
    @Action(DsiRecommAction)
    storeRecomAlerts({getState, patchState}: StateContext<AICdsStateModel>, {payload}: DsiRecommAction) {

        const state = getState();
        patchState({
            recommendationObj: payload,
            
        });
    }
}



 
